import {useNuxtApp} from 'nuxt/app';
import {storeToRefs} from 'pinia';
import {defineNuxtPlugin, useDataTracking, useRoute} from '#imports';
import {useContextStore} from '~/store/context.store';
import {usePageSourceStore} from '~/store/page-source.store';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('page:finish', () => {
        const nuxtApp = useNuxtApp();
        const {$pinia} = nuxtApp;
        const contextStore = useContextStore($pinia);
        const {signupType, edrMatches} = storeToRefs(contextStore);
        const pageSourceStore = usePageSourceStore($pinia);
        const {pageSource} = storeToRefs(pageSourceStore);
        const route = useRoute();

        pageSourceStore.initPageSourceIfNeeded(route);

        const {track} = useDataTracking();

        const funnelStep = route.meta.funnelStepTracking;
        if (!funnelStep) {
            return;
        }

        track('signup_client_funnel_step_viewed', {
            funnel_step: funnelStep,
            ...(pageSource.value ? {page_source: pageSource.value} : {}),
            ...(signupType.value ? {signup_type: signupType.value} : {}),
            ...(edrMatches.value !== undefined ? {email_domain_recognition: edrMatches.value} : {}),
        });
    });
});
